<script>
import BrokerageConsoleLayout from '@layouts/brokerage-console-main'
import PageNavigation from '@components/admin/page-navigation'
import { fetchMemberList, fetchRelationList } from '@apis/brokerage'
import { mapGetters, mapState } from 'vuex'
import date from 'locutus/php/datetime/date'
import pickBy from 'lodash/pickBy'

export default {
  page: {
    title: 'BrokerageConsole::MemberList',
    meta: [{ name: 'description', content: 'BrokerageConsole::MemberList' }],
  },
  components: { BrokerageConsoleLayout, PageNavigation },
  data() {
    return {
      loading: false,
      list: [],
      relations: [],
      total_count: 0,
      page: 1,
      total_page: 0,
      page_navigation: {},
      search_params: {},
    }
  },
  computed: {
    ...mapState('common', { constants: (state) => state.constants }),
    ...mapGetters('brokerage', ['brokerage_info']),
  },
  watch: {
    $route(to, from) {
      this.page = this.$route.query.page || 1
      this.loadList().catch((e) => this.$toasted.error(e.message))
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.page = this.$route.query.page || 1
      this.search_params = { ...this.$route.query }
      Promise.all([this.loadList(), this.loadRelations()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadList() {
      this.loading = true
      const ret_obj = await fetchMemberList({
        ...this.$route.params,
        ...pickBy(this.$route.query, (v) => v !== undefined),
      })

      this.list = ret_obj.data
      this.total_count = ret_obj.total_count
      this.total_page = ret_obj.total_page
      this.page_navigation = ret_obj.page_navigation
    },
    async loadRelations() {
      const { data } = await fetchRelationList({
        ...this.$route.params,
        no_paging: 1,
      })

      this.relations = data
    },
    search() {
      this.$router.push({ query: this.search_params })
    },
    clearAndSearch() {
      this.search_params = {}
      this.search()
    },
    date,
  },
}
</script>

<template>
  <BrokerageConsoleLayout
    ><h3 :class="$style.xeAdmin">{{ $t('admin.search') }}</h3>
    <form @submit.prevent="search">
      <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
        <colgroup>
          <col width="20%" />
          <col width="30%" />
          <col width="20%" />
          <col width="30%" />
        </colgroup>
        <tbody>
          <tr>
            <th scope="col">
              <div>
                {{ $t('brokerage_member_list.sub_broker') }}
              </div>
            </th>
            <td colspan="3">
              <select v-model="search_params.brokerage_seq">
                <option :value="undefined">{{
                  $t('brokerage_member_list.not_selecta')
                }}</option>
                <option
                  v-for="val in relations"
                  :key="val.seq"
                  :value="val.child_seq"
                  >{{ val.child_title }}</option
                >
              </select>
            </td>
          </tr>
          <tr>
            <th colspan="4" :class="$style.button">
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="clearAndSearch"
                ><span>{{ $t('admin.reset') }}</span></a
              >
              &nbsp;
              <span :class="[$style.button, $style.black]"
                ><input type="submit" :value="$t('admin.submit')"
              /></span>
            </th>
          </tr>
        </tbody>
      </table>
    </form>

    <h3 :class="$style.xeAdmin">{{ $t('admin_member_list.member_list') }}</h3>
    <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
      <caption v-if="!loading"
        >Total {{ total_count }}, Page {{ page }}/{{ total_page }}</caption
      >
      <thead>
        <tr>
          <th scope="col"
            ><div
              ><a href="#">{{ $t('admin.num') }}</a></div
            ></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('admin.member_seq') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('admin.user_id') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('admin.user_name') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('admin.email_address') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div
              ><a href="#">{{ $t('admin_member_list.regdate') }}</a></div
            ></th
          >
        </tr>
      </thead>
      <tbody>
        <tr v-for="data in list" :key="data.seq">
          <td :class="$style.tCenter">{{ data._no }}</td>
          <td :class="$style.tCenter">{{ data.seq }}</td>
          <td :class="$style.tCenter">{{ data.user_id }}</td>
          <td :class="$style.tCenter">{{ data.user_name }}</td>
          <td>{{ data.email_address }}</td>
          <td :class="$style.tCenter">{{
            date('Y-m-d H:i:s', new Date(data.regdate))
          }}</td>
        </tr>
        <tr v-if="loading">
          <td colspan="6" :class="$style.tCenter">{{ $t('admin.loading') }}</td>
        </tr>
        <tr v-else-if="!list.length">
          <td colspan="6" :class="$style.tCenter">{{
            $t('brokerage_member_list.msg_not_exist')
          }}</td>
        </tr>
      </tbody>
    </table>
    <PageNavigation
      v-if="!loading"
      :total_count="total_count"
      :total_page="page_navigation.total_page"
      :cur_page="page"
      :page_count="page_navigation.page_count"
    ></PageNavigation>
  </BrokerageConsoleLayout>
</template>
<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
